import React from 'react';
import ErrorDisplay from '../ErrorDisplay';
import { createPortal } from 'react-dom';

class FormErrorComponent extends React.Component {
  render() {
    const { error, dialogIsOpen, type } = this.props;
    const errorStatus = error && !dialogIsOpen ? true : false;
    if (!errorStatus) {
      return <div />;
    }

    return createPortal(
      <div aria-label="form-error-component" data-testid="error-alert">
        <ErrorDisplay
          isFormError={true}
          formType={type}
          errorStatus={errorStatus}
          error={typeof error === 'string' ? { message: error } : error}
        />
      </div>,
      document.body,
    );
  }
}

export default FormErrorComponent;
